<template>
  <div>
    <footer>
      <div class="row clearfix">
        <div class="fivecol">
          <ul class="twelvecol">
            <li class="sixcol">
              <a href="http://liveperformance.com.au" class="lpalogo">
                <img src="http://reports.liveperformance.com.au/img/2018/lpalogo.png" alt="Live Performance Australia">
              </a>
            </li>
            <li class="sixcol last">
              <a href="http://www.ey.com/" class="eylogo">
                <img src="http://reports.liveperformance.com.au/img/2018/eylogo.png" alt="EY">
              </a>
            </li>
          </ul>
          <p>
            &copy; 2025 <a href="http://liveperformance.com.au">Live Performance Australia</a> <br>
            Site by <a href="https://www.collabagency.com.au/">Collab Agency</a><br>
          </p>
        </div>
        <ul class="threecol">
          <li><strong>2025 Live Performance Attendance and Revenue Report</strong></li>
          <li>
            <router-link :to="{name: 'Overview'}" @click.native="scrollToTop">Overview</router-link>
          </li>
          <li>
            <router-link :to="{name: 'States'}" @click.native="scrollToTop">States</router-link>
          </li>
          <li>
            <router-link :to="{name: 'Categories'}" @click.native="scrollToTop">Categories</router-link>
          </li>
          <li>
            <router-link :to="{name: 'Appendix'}" @click.native="scrollToTop">Appendix</router-link>
          </li>
          <li><a href="http://reports.liveperformance.com.au">More LPA Reports</a></li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'FooterNav',
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>

</style>
